import React, { CSSProperties, ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { cssTheme } from '../../../themes';
import { getLinariaClassName } from '../../../utils/getLinariaClassName';
import { ControlType, ControlWithCheckmark } from '../helpers/ControlWithCheckmark';
import { Flex } from '../helpers/Flex';
import { Tag } from '../Tag';
import { Text } from '../Text';
const SIZES = ['md', 'lg'] as const;
type Size = (typeof SIZES)[number];
interface Props {
  selected: boolean;
  dataId?: string;
  name: string;
  onChange: () => void;
  value?: string;
  size?: Size;
  children?: ReactNode;
  labelText?: string;
  withControlButton?: boolean;
  withBorder?: boolean;
  alignCheckmark?: CSSProperties['alignItems'];
  disabled?: boolean;
  className?: string;
  type: ControlType;
  style?: CSSProperties;
  icon?: ReactNode;
  title?: ReactNode;
  isVertical?: boolean;
  hasCheckmarkError?: boolean;
}
const Wrapper = /*#__PURE__*/styled('label')({
  name: "Wrapper",
  class: "wy9ywn5",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1b0gvnw",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1ob8uhu",
  propsAsIs: false
});
const TitleWrapper = /*#__PURE__*/styled('div')({
  name: "TitleWrapper",
  class: "tcgvokr",
  propsAsIs: false
});
const _exp20 = /*#__PURE__*/() => Flex.Row;
const ControlButtonWrapper = /*#__PURE__*/styled(_exp20())({
  name: "ControlButtonWrapper",
  class: "clcispl",
  propsAsIs: true
});
const _exp24 = /*#__PURE__*/() => ({
  size
}) => size === 'lg' ? cssTheme.layout.spacing.s300 : 0;
const SelectionCardBody = /*#__PURE__*/styled('div')({
  name: "SelectionCardBody",
  class: "siloi5s",
  propsAsIs: false,
  vars: {
    "siloi5s-0": [_exp24()]
  }
});
const _exp25 = /*#__PURE__*/() => Tag;
const LabelText = /*#__PURE__*/styled(_exp25())({
  name: "LabelText",
  class: "l1llr0ch",
  propsAsIs: true
});
export const SelectionCard = ({
  selected,
  dataId = 'SelectionCard',
  name,
  onChange,
  value,
  size = 'lg',
  children,
  labelText,
  withControlButton = true,
  withBorder = true,
  disabled = false,
  className,
  alignCheckmark = 'flex-start',
  type = 'radio',
  style,
  icon,
  title,
  isVertical = false,
  hasCheckmarkError
}: Props) => {
  return <Wrapper className={cx(`${getLinariaClassName(Wrapper)}--size-${size}`, withBorder && 'withBorder', selected && 'isSelected', disabled && 'isDisabled', className)} onClick={withControlButton ? undefined : onChange} data-id={dataId} style={style}>
      {labelText && <LabelText className={cx(`--${size}`, selected && 'isSelected', disabled && 'isDisabled')}>
          <Text variant="labelXS">{labelText}</Text>
        </LabelText>}

      <SelectionCardBody className={cx(isVertical && `--vertical`, withControlButton && `--with-control-button`)} size={size}>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        {Boolean(title) && <TitleWrapper>
            <Text variant={size === 'lg' ? 'bodyM' : 'bodyS'}>{title}</Text>
          </TitleWrapper>}
        {children && <ContentWrapper>{children}</ContentWrapper>}
        {withControlButton && <ControlButtonWrapper className={cx(selected && 'isSelected', `--type-${type}`)} alignItems={alignCheckmark}>
            <ControlWithCheckmark type={type} name={name} checked={selected} onChange={onChange} value={value} disabled={disabled} hasError={type === 'checkbox' && hasCheckmarkError} />
          </ControlButtonWrapper>}
      </SelectionCardBody>
    </Wrapper>;
};

require("./SelectionCard.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SelectionCard.tsx");